
// You can write more code here

/* START OF COMPILED CODE */

import Powerup from "../../game/powerups/Powerup";
/* START-USER-IMPORTS */
import { Sounds } from "../../sounds";
import {LevelManager} from "../../game/LevelManager";
/* END-USER-IMPORTS */

export default class PorkyPigPowerup extends Powerup {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // layer4
    const layer4 = scene.add.image(0, 1, "game-tiles", "porky-disc-4.png");
    this.add(layer4);

    // layer3
    const layer3 = scene.add.image(0, 0, "game-tiles", "porky-disc-3.png");
    this.add(layer3);

    // layer2
    const layer2 = scene.add.image(0, -1, "game-tiles", "porky-disc-2.png");
    this.add(layer2);

    // layer1
    const layer1 = scene.add.image(0, 0, "game-tiles", "porky-disc-1.png");
    this.add(layer1);

    // ScoreMultiplierText
    const scoreMultiplierText = scene.add.text(0, 0, "", {});
    scoreMultiplierText.setOrigin(0.5, 0.5);
    scoreMultiplierText.text = "x2";
    scoreMultiplierText.setStyle({ "align": "center", "color": "#ffff00", "fontFamily": "Acme-Regular", "fontSize": "150px" });
    this.add(scoreMultiplierText);

    this.layer4 = layer4;
    this.layer3 = layer3;
    this.layer2 = layer2;
    this.layer1 = layer1;
    this.scoreMultiplierText = scoreMultiplierText;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private layer4: Phaser.GameObjects.Image;
  private layer3: Phaser.GameObjects.Image;
  private layer2: Phaser.GameObjects.Image;
  private layer1: Phaser.GameObjects.Image;
  private scoreMultiplierText: Phaser.GameObjects.Text;

  /* START-USER-CODE */
  public scoreMultiplier:number = 2;
  public duration:number = 3000;
  public affectsScore:boolean = true;

  public override ApplyPowerup(levelManager: LevelManager): void {
    super.ApplyPowerup(levelManager);
    this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.PorkyPig, Sounds.Channel.SFX, {
      volume: 1
    });

    this.layer1.scale = this.layer2.scale = this.layer3.scale = this.layer4.scale = 0;

    this.scoreMultiplierText.text = this.scoreMultiplier+this.scene.app.LocaleHandler.getLocalisedTextById("multiplierPostFix");
    this.scoreMultiplierText.scale = 0;
    this.x = 960;
    this.y = 384;

    this.scene.add.tween({
      targets:this.layer1,
      scale : 1,
      duration:500,
      delay:150,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.scene.add.tween({
      targets:this.layer2,
      scale : 1,
      duration:500,
      delay:100,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.scene.add.tween({
      targets:this.layer3,
      scale : 1,
      duration:500,
      delay:50,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.scene.add.tween({
      targets:this.layer4,
      scale : 1,
      duration:500,
      delay:0,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.scene.add.tween({
      targets:this.scoreMultiplierText,
      scale : 1,
      duration:600,
      delay:450,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.scene.add.tween({
      targets:this.layer1,
      scale : 0,
      duration:300,
      delay:1300,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets:this.layer2,
      scale : 0,
      duration:300,
      delay:1350,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets:this.layer3,
      scale : 0,
      duration:300,
      delay:1400,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets:this.layer4,
      scale : 0,
      duration:300,
      delay:1450,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets:this.scoreMultiplierText,
      scale : 0,
      duration:300,
      delay:1100,
      ease: Phaser.Math.Easing.Back.In
    });
  }

  modifyScore(score: number): number {
    console.log("modify score",score,this.scoreMultiplier);
    return score * this.scoreMultiplier;
  }

  get multiplier(){
    return this.scoreMultiplier;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
